import { EMPTY_FIELD } from 'constants/emptyField';

import { FunctionField } from 'shared/react-admin/Fields';
import { Merchant } from 'types/embedded/merchant';

type Props = {
  label?: string;
  source?: string;
};

export const MerchantPlatformField: React.FC<Props> = ({ label }) => {
  return (
    <FunctionField
      label={label}
      render={(record: Merchant) => {
        if (!record?.platform) {
          return EMPTY_FIELD;
        }

        return record?.platform?.name ?? EMPTY_FIELD;
      }}
    />
  );
};
